export const arr1 = [
  { text: 'Задание: на выделенном участке определи высоту каждого уровня, ориентируясь на шкалу слева. Запиши числовые значения высоты каждого уровня.', buttonTitle: 'Продолжить' },
]

export const arr2 = [
  { text: 'Теперь музыка - это не волна, а последовательность чисел - высот уровней: 21 22 15 18 22 18 21 27 26 22 24 23 15 16 18 15 15 25 26 23 24 28 20 17 20 16 13 17 22 19 20 26 23 21' },
  // { text: 'Последовательность десятичных чисел: 21 22 15 18 22 18 21 27 26 22 24 23 15 16 18 15 15 25 26 23 24 28 20 17 20 16 13 17 22 19 20 26 23 21' },
  { text: 'Но компьютер всю информацию хранит в удобном для себя виде - двоичном коде.' },
  {
 text: 'Двоичная последовательность: \n'
      + '0001010100010110000011110001001000010110000100100001010100011011000110100001011000011000000101110000111100010000000100100000111100001111000110010001101000010111000110000001110000010100000100010001010000010\n',
},
  { text: 'Теперь компьютер может хранить, отправлять и обрабатывать музыку.', buttonTitle: 'Продолжить' },
]

export const task = [
  { text: 'Задание: на выделенном участке определи высоту каждого уровня, ориентируясь на шкалу слева. Запиши числовые значения высоты каждого уровня.' },
]
